import React, { useEffect } from 'react'
import HospitalSidebar from '../../components/HospitalSidebar/HospitalSidebar'
import { useDispatch, useSelector } from 'react-redux'
import { hospitalActions } from '../../_actions'
import LoadingOverlay from 'react-loading-overlay';
import Rating from '@mui/material/Rating';

export default function ReviewRattingHospital() {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  let { hospital } = selector || {};
  let { RattingList, loading } = hospital || {};
  let { getHospitalRatingList } = RattingList || {};
  let { list, total } = getHospitalRatingList || {};
  let data = {
    "keyWord": "",
    "pageNo": 1,
    "size": 10
  }
  useEffect(() => {
    const fetchHospitalRatingList = async () => {
      try {
        dispatch(hospitalActions.getHospitalProfile())
        dispatch(hospitalActions.getHospitalRatingList(data));
        console.log("done")
      } catch (error) {
        console.error("Error fetching hospital rating list:", error);

      }
    };

    fetchHospitalRatingList();
  }, []);
  return (

    <div className='flex'>
      <LoadingOverlay active={loading} className="temp001" spinner text='Please wait...' />
      <div>
        <HospitalSidebar />
      </div>

      <div className='w-full p-2 overflow-y-auto overflow-hidden h-screen pb-32' >
        <div className='bg-gray-200 rounded-lg px-4 py-4 m-2 '>
          <h1 className=' text-xl text-[#0A5F60] font-bold'>REVIEW RATING</h1>
        </div>

        {/* <div className=''> */}
        {
          getHospitalRatingList?.list[0]?.hospitalId?.hospitalRatingList?.map((e) => {
            return (<>
              <div key={e.id} className=' cursor-pointer border-b border-gray-600 p-3 mb-3 hover:scale-[1.01] transition-all ease-in-out  shadow-md  m-2 rounded-lg'>
                <div className='md:flex gap-5 w-full md:space-y-0 space-y-2'>
                  <div className=''>
                    <img className='w-40  h-40  rounded shadow-md' src={e?.userId?.imageLinkUrl || 'https://cdn-icons-png.freepik.com/256/3135/3135715.png?ga=GA1.1.1346393448.1707470564'} alt="Hospital Image" />
                  </div>
                  <div className='flex flex-col space-y-1'>
                    <div>
                      <p className=' text-xl font-bold text-black'>Name : <span className='text-lg font-semibold'>{e?.userId?.fullName}</span></p>
                    </div>
                    <div>
                      <p className=' text-xl font-bold text-black'>Review : <span className='text-lg font-semibold'>{e?.review || " "}</span></p>
                    </div>
                    <div className=' text-lg font-medium'><Rating name="read-only" value={e?.rating} precision={0.5} readOnly /></div>
                  </div>
                </div>
              </div>
            </>

            )
          })
        }
        {/* </div> */}


      </div>

    </div>

    // <div className='flex'>
    //   <LoadingOverlay active={loading} className="temp001" spinner text='Please wait...' />
    //   <div>
    //     <HospitalSidebar />

    //   </div>
    //   <div className='w-full flex '>
    //     <div className='bg-gray-200 rounded-lg p-8 m-2 '>
    //       <h1 className=' text-xl  font-bold'>REVIEW RATING</h1>
    //     </div>
    //     <div>
    //       {
    //         getHospitalRatingList?.list[0]?.hospitalId?.hospitalRatingList?.map((e) => {
    //           return (
    //             <div key={e.id} className=' cursor-pointer border-b border-gray-600 p-3 mb-3 hover:scale-[1.01] transition-all ease-in-out  shadow-md  m-2 rounded-lg'>
    //               <div className='flex md:justify-between flex-col md:flex-row'>
    //                 <div className='flex'>
    //                   <img className=' w-36 h-36 rounded-full' src={e?.userId?.imageLinkUrl || 'https://cdn-icons-png.freepik.com/256/3135/3135715.png?ga=GA1.1.1346393448.1707470564'} />
    //                   <div className=' pl-4 flex flex-col gap-3'>


    //                     <div className='flex items-center'>
    //                       <div className=' text-lg flex font-bold'>
    //                         Name:  <div className=' font-normal'>{e?.userId?.fullName || " "}</div>
    //                       </div>

    //                     </div>



    //                     <div className='flex text-lg items-center'>
    //                       <div className=' flex  font-bold'>
    //                         Review :  <div className=' font-normal'>{e?.review || " "}</div>
    //                       </div>
    //                     </div>


    //                     <div className='flex items-center'>
    //                       <div className=' text-lg font-bold'>
    //                         <Rating name="read-only" value={e?.rating} precision={0.5} readOnly />
    //                       </div>

    //                     </div>



    //                   </div>
    //                 </div>

    //               </div>
    //             </div>
    //           )
    //         })
    //       }
    //     </div>

    //   </div>

    // </div>
  )
}
